module.exports = __webpack_public_path__ + "static/media/news-mental-health-month.3fe4b5f3.jpg";